// extracted by mini-css-extract-plugin
module.exports = {"root":"GiftAid_root__17JA2","backButton":"GiftAid_backButton__11hr4","giftAidAddressName":"GiftAid_giftAidAddressName__3Bss4"};